import Grid from '@mui/material/Grid';
import { BenefitDTO, BenefitDTOBenefitEnum, CouponBenefitDetailsDTO } from 'probonio-shared-ui/api';
import React from 'react';
import { AdditionalBenefitListItemsExtensionInterface } from '../../../extension/interface/additional-benefit-list-items.extension.interface';
import { getBenefitListItemExtension } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitItemCard } from '../../benefit/BenefitItem';

export class CouponsStandaloneAdditionalItemsExtension extends AdditionalBenefitListItemsExtensionInterface {
  getAdditionalItems(activeBenefits: BenefitDTO[]): React.ReactNode[] {
    const additionalItems: React.ReactNode[] = [];

    // Handle standalone coupons using extension
    const couponsBenefit = activeBenefits.find(benefit => benefit.benefit === BenefitDTOBenefitEnum.Coupons);
    if (couponsBenefit) {
      const detailsCoupons = couponsBenefit.details as CouponBenefitDetailsDTO;
      if (
        detailsCoupons &&
        !detailsCoupons.nonCashBenefits.includes(BenefitDTOBenefitEnum.Coupons) &&
        detailsCoupons.allCouponsOrderCount > 0
      ) {
        const couponsExtension = getBenefitListItemExtension(BenefitDTOBenefitEnum.Coupons);
        if (couponsExtension) {
          const standaloneProps = couponsExtension.getListItemProps(couponsBenefit, activeBenefits);
          if (standaloneProps) {
            additionalItems.push(
              <Grid key={'coupons-standalone-item'} size={'grow'}>
                <BenefitItemCard {...standaloneProps} />
              </Grid>,
            );
          }
        }
      }
    }

    return additionalItems;
  }
}
